module.exports = __webpack_public_path__ + "img/2022-22.d22b8976.jpg";